import { store } from '../index';
import {
  Button,
  Grid,
  InputLabel,
  TextField,
  Typography,
} from "@material-ui/core";
import { Textarea } from "@mui/joy";
import React, { useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { aahar_registration } from "../utils/customer_helper";
import FormControlLabel from "@mui/material/FormControlLabel";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import logo from "../assets/images/cyntra_logo.svg";
import Radio from "@mui/material/Radio";
import FormGroup from "@mui/material/FormGroup";
import RadioGroup from "@mui/material/RadioGroup";
import Checkbox from "@mui/material/Checkbox";
import logo1 from "../assets/images/AAHAR.png";
import { TOKEN_KEY } from "../utils/constant";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { send_email } from "../utils/store_helper";

const AaharUserForm = () => {
  let user = store.getState().sessionReducer || {};
  const { store_id } = user;
  const [formDate, setFormDate] = useState(new Date());
  const [activationdateTime, setActivationdateTime] = useState(new Date());
  
  const [thanku, setThanku] = useState(false);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email_id: "",
    phone_no: "",
    company_name: "",
    products: [],
    city: "",
    note: "",
    Business: "",
    Remaining: "",
    address: "",
    industry: "",
    integration: "",
    paid: "",
    subscription: "",
  });

  const handleInputChange = (e) => {
    const { name, value, checked } = e.target;

    if (name === "products") {
      setFormData((prev) => ({
        ...prev,
        [name]: checked
          ? [...prev.products, value]
          : prev.products.filter((item) => item !== value),
      }));
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const postData = async () => {
    const _formData = new FormData();
    Object.keys(formData).forEach((key) => {
      if (key === "file" && formData.file) {
        _formData.append(key, formData.file);
      } else {
        _formData.append(key, formData[key]);
      }
    });

    _formData.append("store_id", store_id);
    _formData.append("dateTime", formDate?.dateTime?.$d);
    _formData.append("activationdateTime", activationdateTime?.activationdateTime);

    for (let pair of _formData.entries()) {
      console.log(`${pair[0]}: ${pair[1]}`);
    }
    try {
      const response = await aahar_registration(_formData);
      if (response) {
        sendEmail()
        setThanku(true);
      }
    } catch (error) {
      console.error("Error while submitting the form:", error);
    }

  };



  const dateValue = formDate?.dateTime?.$d;
  const date = dateValue ? new Date(dateValue) : null;

const options = { 
  weekday: "short", 
  year: "numeric", 
  month: "short", 
  day: "2-digit", 
  hour: "2-digit", 
  minute: "2-digit", 
  second: "2-digit", 
  hour12: false, 
  timeZone: "Asia/Kolkata"
};

// Format the date string
const formattedDate = new Intl.DateTimeFormat("en-US", options).format(date).replace(",", "");

// Append "IST" manually since JS doesn't give timezone abbreviations
const finalDate = `${formattedDate} IST`;


  const sendEmail=async()=>{
    let emailData = {
      to: formData?.email_id,
      subject: "Welcome to CYNTRA! Onboarding Successfully Completed 🎉",
      body: `Dear ${formData?.first_name},
    
    We’re thrilled to inform you that your onboarding process has been successfully completed! You’re now all set to start using our services.
    
    Here are the key details of your setup:
    - Purchased Products: ${formData?.products }
    - Integration: ${formData?.integration }
    - Subscription Type: ${formData?.subscription}
    
    Onboarding & Training:  
    Our team will connect with you on ${finalDate} to set up your system and guide you through the training process.
    
    Need Assistance? Our support team is always available—feel free to reach out at support@cyntra.ai.
    
    We’re excited to have you on board and look forward to a successful collaboration. If you have any questions, don’t hesitate to reach out!
    
    Best Regards,  
    Cyntra Support Team  
    www.cyntra.ai
    `
    };
    
    try {
      const response = await send_email(emailData);
      if (response) {
        console.log("Email Sent:", response);
      }
    } catch (error) {
      console.error("Error while sending the email:", error);
    }
  }

  const handleSubmit = () => {
    postData();
    console.log("Form Submitted:", formData);
  };

  return (
    <div
      style={{
        maxWidth: "500px",
        margin: "0 auto",
        minHeight: "100vh",
        justifyContent: "center",
      }}
    >
      <Grid container style={{ padding: "2rem", justifyContent: "center" }}>
        {thanku ? (
          <Grid
            container
            style={{
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "5rem",
            }}
          >
            <Typography
              variant="h3"
              style={{ fontWeight: "bold", fontFamily: "sans-serif" }}
            >
              Thank You !
            </Typography>
            <Button
              onClick={() =>
                setThanku(false) +
                setFormData({
                  first_name: "",
                  last_name: "",
                  email_id: "",
                  phone_no: "",
                  company_name: "",
                  products: [],
                  city: "",
                  note: "",
                  Business: "",
                  Remaining: "",
                  address: "",
                  industry: "",
                  integration: "",
                  paid: "",
                  subscription: "",
                })
              }
              style={{
                background: "#1976d2",
                color: "white",
                marginTop: "2rem",
                minWidth: "100px",
              }}
              variant="contained"
              type="submit"
            >
              ok
            </Button>
          </Grid>
        ) : (
          <>
            <Grid
              container
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <img alt="logo" width={"45%"} src={logo} />
              <img alt="logo" width={"45%"} src={logo1} />
            </Grid>

            <Typography
              variant="h3"
              style={{
                fontWeight: "bold",
                fontFamily: "sans-serif",
                fontSize: "2rem",
              }}
            >
              New Client Onboarding
            </Typography>
            <Grid container style={{ marginTop: "2rem" }}>
              <div style={{ minWidth: "100%" }}>
                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <Grid xs={4} sm={4} md={4} lg={4}>
                    <Typography
                      style={{ textAlign: "left", fontWeight: "600" }}
                    >
                      First Name:
                    </Typography>
                  </Grid>
                  <Grid xs={8} sm={8} md={8} lg={8}>
                    <TextField
                      fullWidth
                      name="first_name"
                      placeholder="Enter your first name"
                      value={formData.first_name}
                      onChange={handleInputChange}
                      variant="outlined"
                      size="small"
                    ></TextField>
                  </Grid>
                </Grid>

                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <Grid xs={4} sm={4} md={4} lg={4}>
                    <Typography
                      style={{ textAlign: "left", fontWeight: "600" }}
                    >
                      Last Name:
                    </Typography>
                  </Grid>
                  <Grid xs={8} sm={8} md={8} lg={8}>
                    <TextField
                      fullWidth
                      name="last_name"
                      placeholder="Enter your last name"
                      value={formData.last_name}
                      onChange={handleInputChange}
                      variant="outlined"
                      size="small"
                    ></TextField>
                  </Grid>
                </Grid>

                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <Grid xs={4} sm={4} md={4} lg={4}>
                    <Typography
                      style={{ textAlign: "left", fontWeight: "600" }}
                    >
                      Email ID:
                    </Typography>
                  </Grid>
                  <Grid xs={8} sm={8} md={8} lg={8}>
                    <TextField
                      fullWidth
                      type="email"
                      placeholder="Enter a your email"
                      name="email_id"
                      value={formData.email_id}
                      onChange={handleInputChange}
                      variant="outlined"
                      size="small"
                    ></TextField>
                  </Grid>
                </Grid>

                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <Grid xs={4} sm={4} md={4} lg={4}>
                    <Typography
                      style={{ textAlign: "left", fontWeight: "600" }}
                    >
                      Phone No.:
                    </Typography>
                  </Grid>
                  <Grid xs={8} sm={8} md={8} lg={8}>
                    <TextField
                      fullWidth
                      type="tel"
                      placeholder="Enter a your phone number"
                      name="phone_no"
                      value={formData.phone_no}
                      onChange={handleInputChange}
                      variant="outlined"
                      size="small"
                    ></TextField>
                  </Grid>
                </Grid>

                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <Grid xs={4} sm={4} md={4} lg={4}>
                    <Typography
                      style={{ textAlign: "left", fontWeight: "600" }}
                    >
                      Company:
                    </Typography>
                  </Grid>
                  <Grid xs={8} sm={8} md={8} lg={8}>
                    <TextField
                      fullWidth
                      type="text"
                      placeholder="Enter your registered business name"
                      name="company_name"
                      value={formData.company_name}
                      onChange={handleInputChange}
                      variant="outlined"
                      size="small"
                    ></TextField>
                  </Grid>
                </Grid>

                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <Grid xs={4} sm={4} md={4} lg={4}>
                    <Typography
                      style={{ textAlign: "left", fontWeight: "600" }}
                    >
                      Industry Type:
                    </Typography>
                  </Grid>
                  <Grid
                    container
                    style={{ marginLeft: "1rem" }}
                    xs={8}
                    sm={8}
                    md={8}
                    lg={8}
                  >
                    <FormControl>
                      <RadioGroup
                        row
                        value={formData.industry}
                        onChange={handleInputChange}
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="industry"
                      >
                        <FormControlLabel
                          value="F&B"
                          control={<Radio />}
                          label="F&B"
                        />
                        <FormControlLabel
                          value="Retail"
                          control={<Radio />}
                          label="Retail"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <Grid xs={4} sm={4} md={4} lg={4}>
                    <Typography
                      style={{ textAlign: "left", fontWeight: "600" }}
                    >
                      Business Details:
                    </Typography>
                  </Grid>
                  <Grid xs={8} sm={8} md={8} lg={8}>
                    <Textarea
                      minRows={2}
                      placeholder="Briefly describe your business operations"
                      name="Business"
                      value={formData.Business}
                      onChange={handleInputChange}
                    />
                  </Grid>
                </Grid>

                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <Grid xs={4} sm={4} md={4} lg={4}>
                    <Typography
                      style={{ textAlign: "left", fontWeight: "600" }}
                    >
                      Address:
                    </Typography>
                  </Grid>
                  <Grid xs={8} sm={8} md={8} lg={8}>
                    <TextField
                      fullWidth
                      type="text"
                      name="address"
                      placeholder="Enter your complete business address)"
                      value={formData.address}
                      onChange={handleInputChange}
                      variant="outlined"
                      size="small"
                    ></TextField>
                  </Grid>
                </Grid>

                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <Grid xs={4} sm={4} md={4} lg={4}>
                    <Typography
                      style={{ textAlign: "left", fontWeight: "600" }}
                    >
                      City:
                    </Typography>
                  </Grid>
                  <Grid xs={8} sm={8} md={8} lg={8}>
                    <TextField
                      fullWidth
                      type="text"
                      placeholder="Enter the city where your business operates"
                      name="city"
                      value={formData.city}
                      onChange={handleInputChange}
                      variant="outlined"
                      size="small"
                    ></TextField>
                  </Grid>
                </Grid>

                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <Grid xs={4} sm={4} md={4} lg={4}>
                    <Typography
                      style={{ textAlign: "left", fontWeight: "600" }}
                    >
                      Products:
                    </Typography>
                  </Grid>
                  <Grid xs={8} sm={8} md={8} lg={8}>
                    <FormGroup row>
                      {["Leap", "Breez", "Swyft", "Signa", "Kds", "Cds"].map(
                        (product) => (
                          <FormControlLabel
                            key={product}
                            control={
                              <Checkbox
                                name="products"
                                value={product}
                                checked={formData.products.includes(product)}
                                onChange={handleInputChange}
                              />
                            }
                            label={product}
                          />
                        )
                      )}
                    </FormGroup>
                  </Grid>
                </Grid>

                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <Grid xs={4} sm={4} md={4} lg={4}>
                    <Typography
                      style={{ textAlign: "left", fontWeight: "600" }}
                    >
                      Integration Type:
                    </Typography>
                  </Grid>

                  <Grid container xs={8} sm={8} md={8} lg={8}>
                    <FormControl>
                      <RadioGroup
                        row
                        value={formData.integration}
                        onChange={handleInputChange}
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="integration"
                      >
                        <FormControlLabel
                          value="Cyntra"
                          control={<Radio />}
                          label="Cyntra"
                        />
                        <FormControlLabel
                          value="Petpooja"
                          control={<Radio />}
                          label="Petpooja"
                        />
                        <FormControlLabel
                          value="Rista"
                          control={<Radio />}
                          label="Rista"
                        />
                        <FormControlLabel
                          value="UrbanPiper"
                          control={<Radio />}
                          label="UrbanPiper"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <Grid xs={4} sm={4} md={4} lg={4}>
                    <Typography
                      style={{ textAlign: "left", fontWeight: "600" }}
                    >
                      Note:
                    </Typography>
                  </Grid>
                  <Grid xs={8} sm={8} md={8} lg={8}>
                    <Textarea
                      minRows={2}
                      name="note"
                      placeholder="Add any additional comments or special requirements"
                      value={formData.note}
                      onChange={handleInputChange}
                    />
                  </Grid>
                </Grid>
                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <Grid xs={4} sm={4} md={4} lg={4}>
                    <Typography
                      style={{ textAlign: "left", fontWeight: "600" }}
                    >
                      Preferred Commun... Date & Time:
                    </Typography>
                  </Grid>
                  <Grid xs={8} sm={8} md={8} lg={8}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimePicker
                        fullWidth
                        name="dateTime"
                        minDate={dayjs()}
                        value={formDate.dateTime}
                        onChange={(newValue) => {
                          setFormDate((prev) => ({
                            ...prev,
                            dateTime: newValue,
                          }));
                        }}
                        slotProps={{ textField: { fullWidth: true } }}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>

                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <Grid xs={4} sm={4} md={4} lg={4}>
                    <Typography
                      style={{ textAlign: "left", fontWeight: "600" }}
                    >
                      Activation Date:
                    </Typography>
                  </Grid>
                  <Grid xs={8} sm={8} md={8} lg={8}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        fullWidth
                        name="activationdateTime"
                        minDate={dayjs()}
                        value={activationdateTime.activationdateTime}
                        onChange={(newValue) => {
                          setActivationdateTime((prev) => ({
                            ...prev,
                            activationdateTime: newValue,
                          }));
                        }}
                        slotProps={{ textField: { fullWidth: true } }}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>

                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <Grid xs={4} sm={4} md={4} lg={4}>
                    <Typography
                      style={{ textAlign: "left", fontWeight: "600" }}
                    >
                      Subscription Type:
                    </Typography>
                  </Grid>
                  <Grid xs={8} sm={8} md={8} lg={8}>
                    <FormControl fullWidth size="small">
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        name="subscription"
                        value={formData.subscription || ""}
                        onChange={handleInputChange}
                        displayEmpty
                      >
                        <MenuItem value="" disabled>
                          Select Subscription
                        </MenuItem>
                        <MenuItem value="Silver">Silver</MenuItem>
                        <MenuItem value="Gold">Gold</MenuItem>
                        <MenuItem value="Platinum">Platinum</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <Grid xs={4} sm={4} md={4} lg={4}>
                    <Typography
                      style={{ textAlign: "left", fontWeight: "600" }}
                    >
                      Amount Paid:
                    </Typography>
                  </Grid>
                  <Grid xs={8} sm={8} md={8} lg={8}>
                    <TextField
                      fullWidth
                      type="number"
                      name="paid"
                      placeholder="Enter the amount paid"
                      value={formData.paid}
                      onChange={handleInputChange}
                      variant="outlined"
                      size="small"
                    ></TextField>
                  </Grid>
                </Grid>

                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <Grid xs={4} sm={4} md={4} lg={4}>
                    <Typography
                      style={{ textAlign: "left", fontWeight: "600" }}
                    >
                      Amount Remaining:
                    </Typography>
                  </Grid>
                  <Grid xs={8} sm={8} md={8} lg={8}>
                    <TextField
                      fullWidth
                      type="number"
                      name="Remaining"
                      placeholder="Enter the balance amount"
                      value={formData.Remaining}
                      onChange={handleInputChange}
                      variant="outlined"
                      size="small"
                    ></TextField>
                  </Grid>
                </Grid>

                <Button
                  onClick={() => handleSubmit()}
                  style={{
                    background: "#1976d2",
                    color: "white",
                    marginTop: "2rem",
                    minWidth: "100px",
                  }}
                  variant="contained"
                  type="submit"
                >
                  Submit
                </Button>
              </div>
            </Grid>
          </>
        )}
      </Grid>
    </div>
  );
};

export default AaharUserForm;
